import { Component } from "react";
import { connect } from "react-redux";
import TagsInput from "react-tagsinput";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import FormSelect from "components/DigiHapi/FormSelect";

import {
	SET_TEMPLATE_NAME_ERROR,
	SET_TEMPLATE_DESCRIPTION_ERROR,
	SET_TEMPLATE_NAME_FR,
	SET_ACTIVITY_DESCRIPTION_FR,
	SET_ACTIVITY_POST_DESCRIPTION_FR,
	SET_CHOICES_TAGS,
	SELECT_ACTIVITY_CHOICE_FR,
	STEP2_VALIDATED,
	SET_ACTIVITY_GOODDEAL_DESCRIPTION_FR,
	SET_ACTIVITY_GOODDEAL_POST_DESCRIPTION_FR
} from "actions/types";

class Step2_Activities extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, name, choices, description } = this.props;

		let success = true;
		if (!name) {
			dispatch({
				type: SET_TEMPLATE_NAME_ERROR
			});
			success = false;
		}

		if (choices) {
			for (const choice of Object.values(choices)) {
				if (!choice.description) {
					dispatch({
						type: SET_TEMPLATE_DESCRIPTION_ERROR,
						choiceId: choice.name
					});
					success = false;
					break;
				}
			}
		} else if (!description) {
			dispatch({
				type: SET_TEMPLATE_DESCRIPTION_ERROR
			});
			success = false;
		}

		if (success) {
			dispatch({
				type: STEP2_VALIDATED
			});
		}

		return success;
	}

	handleTags = choices => {
		const { dispatch } = this.props;

		dispatch({
			type: SET_CHOICES_TAGS,
			payload: choices
		});
	};

	render() {
		const {
			dispatch,
			nameErrorMsg,
			descriptionErrorMsg,
			name,
			choices,
			choicesTags,
			choiceId,
			description,
			postDescription,
			gooddealDescription,
			gooddealPostDescription
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDInput
						label="Nom *"
						id="name-fr"
						fullWidth
						error={!!nameErrorMsg}
						helperText={nameErrorMsg}
						value={name || ""}
						onChange={e =>
							dispatch({
								type: SET_TEMPLATE_NAME_FR,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDTypography variant="button" fontWeight="medium">
						Choix
					</MDTypography>
					<TagsInput
						value={choicesTags}
						onChange={this.handleTags}
						tagProps={{
							className: "react-tagsinput-tag info"
						}}
						inputProps={{ placeholder: "Ajouter un choix" }}
					/>
				</Grid>
				{choices && (
					<Grid item xs={12}>
						<FormSelect
							label="Sélectionner le choix à mettre à jour"
							value={choiceId}
							placeholder="Choix"
							options={Object.values(choices).map(({ name }) => ({
								value: name,
								label: name
							}))}
							onChange={e =>
								dispatch({
									type: SELECT_ACTIVITY_CHOICE_FR,
									payload: e.target.value
								})
							}
						/>
					</Grid>
				)}
				<Grid item xs={12}>
					<MDInput
						label="Description *"
						id="description-fr"
						fullWidth
						multiline
						rows={5}
						error={!!descriptionErrorMsg}
						helperText={descriptionErrorMsg}
						value={description || ""}
						onChange={e =>
							dispatch({
								type: SET_ACTIVITY_DESCRIPTION_FR,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Post photo description"
						id="post-description-fr"
						fullWidth
						multiline
						rows={3}
						value={postDescription || ""}
						onChange={e =>
							dispatch({
								type: SET_ACTIVITY_POST_DESCRIPTION_FR,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description pour bons plans"
						id="descrption-gooddeal-fr"
						fullWidth
						multiline
						rows={5}
						value={gooddealDescription || ""}
						onChange={e =>
							dispatch({
								type: SET_ACTIVITY_GOODDEAL_DESCRIPTION_FR,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description après photo pour bons plans"
						id="post-description-gooddeal-fr"
						fullWidth
						multiline
						rows={3}
						value={gooddealPostDescription || ""}
						onChange={e =>
							dispatch({
								type: SET_ACTIVITY_GOODDEAL_POST_DESCRIPTION_FR,
								payload: e.target.value
							})
						}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		name,
		choices,
		nameErrorMsg,
		descriptionErrorMsg,
		choicesTags,
		choiceId,
		description,
		postDescription,
		gooddealDescription,
		gooddealPostDescription
	} = state.templateReducer;

	return {
		name,
		choices,
		nameErrorMsg,
		descriptionErrorMsg,
		choicesTags,
		choiceId,
		description,
		postDescription,
		gooddealDescription,
		gooddealPostDescription
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step2_Activities
);
